import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import NavBar from '~/components/Nav/Bar'

export const Nav = ({ tabs, logoColors }) => {
  const lineItems = useSelector(
    state => state.cart.data.lineItems,
    shallowEqual,
  )

  const itemCount =
    lineItems && lineItems.reduce((acc, item) => acc + item.quantity, 0)

  return <NavBar itemCount={itemCount} tabs={tabs} logoColors={logoColors} />
}

export default Nav
